import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.datasource_ls_assignment"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("my_tasks.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c("search-tableau", {
                        attrs: { showDomains: false },
                        on: { onSearchQuery: _vm.onSearchQuery },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _vm.items.length == 0
              ? _c("StateComponent", {
                  attrs: {
                    state: "empty_state",
                    title: _vm.$t("my_tasks.no_objects"),
                    subtitle: _vm.$t("my_tasks.no_objects_subtitle"),
                  },
                })
              : _c(
                  VCard,
                  [
                    _c(VDataTable, {
                      staticClass: "table-inca",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.items,
                        "hide-default-footer": "",
                        "items-per-page": _vm.pagination.limit,
                        page: _vm.pagination.current,
                      },
                      on: {
                        pagination: function ($event) {
                          _vm.pagination.total = $event.itemsLength
                        },
                        "update:page": function ($event) {
                          return _vm.$set(_vm.pagination, "current", $event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.object_name",
                          fn: function (row) {
                            return [
                              _c("div", { staticClass: "text-left" }, [
                                _c("b", { staticClass: "table-name" }, [
                                  _vm._v(_vm._s(row.item.object_name)),
                                ]),
                                _c("a", {
                                  staticClass: "compose-name",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.composeName(row.item)
                                    ),
                                  },
                                }),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.action",
                          fn: function (row) {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onClickAssign(
                                                          row.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-user_add"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("my_tasks.assign"))),
                                  ]),
                                ]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "btn-icon-inca",
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.syncTableauDatasource(
                                                          row.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-renew"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("my_tasks.sync"))),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
            _c("pagination-vue", {
              attrs: { pagination: _vm.pagination },
              on: { changePagina: _vm.changePagina },
            }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_tasks.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c("search-tableau", {
                          attrs: { showDomains: false },
                          on: { onSearchQuery: _vm.onSearchQuery },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        { ref: _vm.DIALOG_ASSIGN, attrs: { custom_title: true, width: 1200 } },
        [
          _c("template", { slot: "title" }, [
            _c(
              "span",
              {
                staticClass: "h5 mb-2 pointer",
                staticStyle: { color: "#044999" },
              },
              [
                _vm.show_table
                  ? _c("b-icon", {
                      staticClass: "mr-2",
                      attrs: {
                        icon: "arrow-left-square-fill",
                        title: "Previous Page",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onReferenceClose()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(
              _vm._s(
                !_vm.show_table
                  ? _vm.$t("my_tasks.assign_modal")
                  : _vm.$t("my_tasks.metadata")
              )
            ),
          ]),
          _c("template", { slot: "body" }, [
            !_vm.show_table
              ? _c(
                  "div",
                  [
                    _c("form-meta-datasource-datastudio", {
                      key: _vm.key_assign,
                      ref: _vm.DIALOG_ASSIGN + "_body",
                      attrs: {
                        item: _vm.data_ds,
                        dataset_id: _vm.data_ds.dataset_id,
                        readonly: _vm.is_prod_called ? true : false,
                        isChangeRequest: _vm.is_prod_called
                          ? _vm.TYPE_CHANGE_METADA.VIEWER_ONLY
                          : _vm.ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR,
                      },
                      on: {
                        onCloseModal: _vm.onCloseModal,
                        onSave: _vm.refreshItem,
                        onShowTable: _vm.onShowTable,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.show_table
              ? _c(
                  "div",
                  { staticClass: "d-block" },
                  [
                    _c("form-metadata", {
                      attrs: {
                        is_reference_view: _vm.show_table,
                        tplToWork: _vm.objToRequest,
                        isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                      },
                      on: {
                        onReferenceClose: _vm.onReferenceClose,
                        cancel: _vm.onReferenceClose,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { id: "popover-target-1", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.DIALOG_ASSIGN + "_body"].onSave()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "md-16", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }